/**
 * @hidden
 */
export function getRef(comp, refName, customRef) {
    return comp.v3 ? comp["".concat(refName, "Ref")] : comp.$refs["".concat(customRef || refName)];
}
/**
 * @hidden
 */
export function setRef(comp, refName, customRef) {
    return (comp.v3 ? function (el) {
        comp["".concat(refName, "Ref")] = el;
    } : customRef || refName);
}
